/*
  Arkaim Home gift note, 31 Oct 2026; kind-words check added 1 Nov 2026.
  When a customer writes a gift message in the bag, the recipient's email address is required
  before Checkout. Messages with offensive words can't go through to Checkout until the words are
  changed (whole words only, so names like Scunthorpe are fine). Nothing changes for customers
  who leave the note empty.
  Markup: snippets/gift-note-email.liquid. Loaded from layout/theme.liquid.
*/
(function () {
  if (window.__arkaimGiftNote) return;
  window.__arkaimGiftNote = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var ATTR = 'Gift recipient email';
  var FORM_SEL = 'form.cart__form, form.quick-cart__form';
  var NOTE_MSG = 'Some words in your message can’t be sent. Please change them to continue.';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Word list (encoded so it doesn't show as plain text in the page source).
  var LIST = { s: [], w: [], p: [], a: [] };
  try { LIST = JSON.parse(atob('eyJzIjpbImZ1Y2siLCJmdWsiLCJmY2siLCJmY3VrIiwic2hpdCIsImN1bnQiLCJ3YW5rIiwidHdhdCIsImJvbGxvY2siLCJiaXRjaCIsInNsdXQiLCJ3aG9yZSIsIm5pZ2ciLCJmYWdnb3QiLCJyZXRhcmQiLCJtb3RoZXJmIiwiYXJzZWhvbGUiLCJhc3Nob2xlIiwiYmVsbGVuZCIsImRpY2toZWFkIiwiY29ja3N1Y2siLCJzcGFzdGljIiwidG9zc2VyIiwia25vYmhlYWQiLCJzaGl0aGVhZCIsImRpcHNoaXQiLCJqaXp6Il0sInciOlsiY29jayIsImNvY2tzIiwicHJpY2siLCJwcmlja3MiLCJhcnNlIiwicGlzcyIsInRpdHMiLCJzbGFnIiwic2xhZ3MiLCJwYWtpIiwicGFraXMiLCJjaGluayIsImNoaW5rcyIsImdvb2siLCJraWtlIiwic3BpYyIsImNvb24iLCJjb29ucyIsIndvZyIsIndvZ3MiLCJ0cmFubnkiLCJkeWtlIiwiZHlrZXMiLCJub25jZSIsIm1pbmdlIiwiY3VtIiwicmFwZSIsInJhcGVkIiwicmFwaXN0IiwicG9ybiIsInNwYXoiLCJmYWciLCJreXMiLCJza2FuayJdLCJwIjpbImtpbGwgeW91cnNlbGYiLCJraWxsIHVyc2VsZiIsImtpbGwgeW91ciBzZWxmIiwiZ28gZGllIiwiaG9wZSB5b3UgZGllIiwiZHJvcCBkZWFkIl0sImEiOlsic2hpdGFrZSIsInNoaXRha2VzIl19')); } catch (e) {}

  var LEET = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', '$': 's', '!': 'i' };
  function squeeze(s) { return s.replace(/([a-z])\1+/g, '$1'); }
  function norm(text) {
    return String(text || '').toLowerCase().replace(/[013457@$!]/g, function (c) { return LEET[c]; });
  }
  function hits(tokens, squeezed) {
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (!t || (LIST.a && LIST.a.indexOf(t) !== -1)) continue;
      for (var a = 0; a < LIST.s.length; a++) {
        var st = squeezed ? squeeze(LIST.s[a]) : LIST.s[a];
        if (squeezed && st.length < 4) continue;
        if (t.indexOf(st) === 0) return true;
      }
      for (var b = 0; b < LIST.w.length; b++) {
        var w = squeezed ? squeeze(LIST.w[b]) : LIST.w[b];
        if (squeezed && w.length < 4) continue;
        if (t === w) return true;
      }
    }
    return false;
  }
  function isUnkind(text) {
    var n = norm(text);
    if (!n.trim()) return false;
    var flat = ' ' + n.replace(/[^a-z]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
    for (var i = 0; i < LIST.p.length; i++) {
      if (flat.indexOf(' ' + LIST.p[i] + ' ') !== -1) return true;
    }
    var tokens = n.split(/[^a-z]+/);
    if (hits(tokens, false)) return true;
    return hits(tokens.map(squeeze), true);
  }
  window.ArkaimGiftNoteCheck = isUnkind;

  function noteError(form, note) {
    var el = form.querySelector('[data-gift-note-error]');
    if (!el && note && note.parentNode) {
      el = document.createElement('p');
      el.className = 'gift-note-email__error fs-body-75';
      el.setAttribute('data-gift-note-error', '');
      el.setAttribute('role', 'alert');
      el.hidden = true;
      el.textContent = NOTE_MSG;
      note.parentNode.insertBefore(el, note.nextSibling);
    }
    return el;
  }

  function parts(form) {
    var note = form.querySelector('textarea[name="note"]');
    return {
      note: note,
      noteError: noteError(form, note),
      email: form.querySelector('[data-gift-email]'),
      error: form.querySelector('[data-gift-email-error]'),
      express: form.querySelector('.additional-checkout-buttons'),
      noteWrapper: form.querySelector('.cart__footer-order-note-wrapper, .quick-cart__footer-order-note-wrapper'),
      noteTrigger: form.querySelector('[data-order-note-trigger]')
    };
  }

  function state(form) {
    var p = parts(form);
    var note = p.note ? p.note.value.trim() : '';
    var email = p.email ? p.email.value.trim() : '';
    var kind = !isUnkind(note);
    var emailOk = note.length === 0 || EMAIL_RE.test(email);
    return {
      p: p,
      hasNote: note.length > 0,
      email: email,
      kind: kind,
      emailOk: emailOk,
      valid: kind && emailOk
    };
  }

  function refresh(form) {
    var s = state(form);
    if (s.p.express) s.p.express.style.display = s.valid ? '' : 'none';
    if (s.p.noteError) s.p.noteError.hidden = s.kind;
    if (s.p.note) {
      if (s.kind) s.p.note.removeAttribute('aria-invalid');
      else s.p.note.setAttribute('aria-invalid', 'true');
    }
    if (s.emailOk && s.p.error) {
      s.p.error.hidden = true;
      if (s.p.email) s.p.email.removeAttribute('aria-invalid');
    }
  }

  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); }
    if (el.scrollIntoView) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function showError(form) {
    var s = state(form);
    if (s.p.noteWrapper && s.p.noteWrapper.getAttribute('aria-expanded') === 'false' && s.p.noteTrigger) {
      s.p.noteTrigger.click();
    }
    if (!s.kind) {
      if (s.p.noteError) s.p.noteError.hidden = false;
      if (s.p.note) s.p.note.setAttribute('aria-invalid', 'true');
      focusEl(s.p.note);
      return;
    }
    if (s.p.error) s.p.error.hidden = false;
    if (s.p.email) {
      s.p.email.setAttribute('aria-invalid', 'true');
      focusEl(s.p.email);
    }
  }

  function save(form) {
    var s = state(form);
    var body = { attributes: {} };
    body.attributes[ATTR] = s.email;
    if (s.p.note) body.note = s.p.note.value;
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  var timer = null;
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    var isEmail = t.matches('[data-gift-email]');
    var isNote = t.matches('textarea[name="note"]');
    if (!isEmail && !isNote) return;
    var form = t.closest('form');
    if (!form) return;
    refresh(form);
    if (isEmail) {
      clearTimeout(timer);
      timer = setTimeout(function () { save(form); }, 500);
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gift-email]')) return;
    var form = t.closest('form');
    if (!form) return;
    clearTimeout(timer);
    save(form);
  }, true);

  // Checkout button: only steps in when a message has been written.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || !form.matches(FORM_SEL)) return;
    var s = state(form);
    if (!s.hasNote) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (!s.valid) { showError(form); return; }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    save(form).then(function () {
      window.location.href = root + 'checkout';
    });
  }, true);

  // Belt and braces: a submit that reaches the form with an unkind message, or a message and no email, is stopped too.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM_SEL)) return;
    var s = state(form);
    if (!s.hasNote || s.valid) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError(form);
  }, true);

  var pending = null;
  function init() {
    var forms = document.querySelectorAll(FORM_SEL);
    for (var i = 0; i < forms.length; i++) refresh(forms[i]);
  }
  function scheduleInit() {
    clearTimeout(pending);
    pending = setTimeout(init, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:updated', scheduleInit);
  if (window.MutationObserver && document.body) {
    new MutationObserver(scheduleInit).observe(document.body, { childList: true, subtree: true });
  }
})();
